// ESM shim – resolved by the Vite alias for `'moment'`.
// Mirrors the `"module.exports"`-named export trick in jquery-global-shim.js:
// it tells Rolldown's CJS interop to hand require('moment') consumers (e.g.
// pc-bootstrap4-datetimepicker's bundled UMD factory) the raw moment function
// directly, instead of an ESM namespace object ({ default: moment, … }) whose
// `.locale`/`.tz` etc. are undefined.
import moment from 'moment/moment.js';
if (typeof window !== 'undefined') {
    window.moment = window.moment || moment;
}
export default moment;
export { moment as "module.exports" };
